import { Injectable } from '@angular/core';
import { HttpService } from './shared/services/http-service.service';
import { environment } from './../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppserviceService {
  constructor(private httpService: HttpService) {}

  ValidateToken(): Observable<any> {
    return this.httpService.post(environment.ValidateToken, '');
  }
}
